
<!--
 * @Description: 布置作业
 * @Author: 王丽欣
 * @Date: 2023-03-01 17:32:04
 * @LastEditors: PF
 * @LastEditTime: 2024-02-02 13:30:23
-->
<template>
  <div>
    <el-dialog class="wp80 hp80" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">布置作业</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pt0 pr0 pb0">
        <el-container>
          <el-main>
            <el-descriptions :column="4" border>
              <el-descriptions-item label="学期" label-align="right" align="left" width="120px" span="2">{{ruleForm.xqmc}}</el-descriptions-item>
              <el-descriptions-item label="课程" label-align="right" align="left" width="120px" span="2">{{ruleForm.kcmc}}</el-descriptions-item>
              <el-descriptions-item label="周次" label-align="right" align="left" width="120px" span="2"><span v-if="ruleForm.zc">第{{ruleForm.zc}}周</span></el-descriptions-item>
              <el-descriptions-item label="班级/节次" label-align="right" align="left" width="120px" span="2"><span>{{ruleForm.bjmc}} / 星期{{week[ruleForm.xq]}} 第{{ruleForm.jc}}节</span></el-descriptions-item>
              <el-descriptions-item label="教学单元" label-align="right" align="left" width="120px" span="2">{{ruleForm.jxdybt}}</el-descriptions-item>
              <el-descriptions-item label="教学内容" label-align="right" align="left" width="120px" span="2">{{ruleForm.jxnrbt}}</el-descriptions-item>
              <el-descriptions-item label="作业" label-align="right" align="left" width="120px" span="2">{{ruleForm.zuoyemingc}}</el-descriptions-item>
              <el-descriptions-item label="作业类型" label-align="right" align="left" width="120px" span="2">{{ruleForm.zylxmc}}</el-descriptions-item>
              <el-descriptions-item label="截止时间" label-align="right" align="left" width="120px" span="2">{{ruleForm.jzsj}}</el-descriptions-item>
              <el-descriptions-item label="计入平时成绩" label-align="right" align="left" width="120px" span="2">
                <span v-if="ruleForm.sfjrpscj === true">是</span>
                <span v-if="ruleForm.sfjrpscj === false">否</span>
              </el-descriptions-item>
            </el-descriptions>
          </el-main>
        </el-container>
      </div>
    </el-dialog>
  </div>
</template>
<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'
import { closeWindow, actionPost } from '@/api/common.js'
import { warningPrompt } from '@/utils/promptInfo.js'

const props = defineProps({ openDetail: { type: Boolean, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['update:openDetail'])

const row = ref()
const ruleForm = ref({})
const week = ref(['', '一', '二', '三', '四', '五', '六', '日'])

watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      row.value = props.row
      
      // 获取详情
      actionPost({
        url: '/api/v2/ziyuanku/xueshengzuoye/dangqianjiaoshibuzhizouye',
        data: { bjid: row.value.bjid, kcid: row.value.kcid, xqid: row.value.xqid, zc: row.value.zc, xq: row.value.xq, jc: row.value.jc }
      }).then((res) => {
        if (res.code === 200) {
          ruleForm.value = res.data
        } else {
          warningPrompt(res.message)
        }
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
